import CatalogSelect from './CatalogSelectAggregator';

export default CatalogSelect;
